const baseUrl = window.__MC__CONFIG__.apiUrl;

class SepBrand26ClaimComponent extends HTMLElement {
  constructor() {
    super();
    // 活动初始化查询接口
    this.checkUrl = `${baseUrl}/api/station/brandWarmup/info`;
    // 礼品领取接口
    this.apiUrl = `${baseUrl}/api/station/brandWarmup/giftCard/claim`;
    // 当前会话内的领取意图标记
    this.claimIntentStorageKey = "sepBrand26:claim:intent";
    // 当前模块对应的唯一页面标识
    this.pageClaimKey = "";
    this.currentToken = "";
    this.config = {
      loginText: this.dataset.loginText || "Log In to Claim",
      claimText: this.dataset.claimText || "Claim Now",
      claimedText: this.dataset.claimedText || "Claimed",
      claimingText: this.dataset.claimingText || "Claiming...",
      stockExhaustedText: this.dataset.stockExhaustedText || "Out of Stock",
      toastSuccess:
        this.dataset.toastSuccess || "Successfully claimed your gift card!",
      toastError:
        this.dataset.toastError || "Failed to claim. Please try again.",
      toastStockExhausted:
        this.dataset.toastStockExhausted || "Gift cards are out of stock.",
    };
  }

  connectedCallback() {
    this.button = this.querySelector("[data-claim-button]");
    this.buttonText = this.querySelector("[data-button-text]");
    this.rootEl = this.querySelector(".sep-brand26-gift-card");
    if (!this.button || !this.buttonText) return;

    // 生成当前模块唯一 key，并开始监听当前按钮点击
    this.pageClaimKey = this.buildPageClaimKey();
    this.bindIntentCapture();

    // 初始化时禁用按钮，等待状态检查完成
    this.button.disabled = true;

    const token = this.getToken();
    if (!token) {
      // 未登录：按钮显示登录文案
      this.setLoginRequired();
    } else {
      // 已登录：进入状态检查
      this.checkStatus(token);
    }

    // 监听登录成功事件（loginDialog 登录不重定向时会触发）
    this.onLoginHandler = (e) => {
      const newToken =
        e.detail && e.detail.token ? e.detail.token : this.getToken();
      if (newToken) {
        this.checkStatus(newToken);
      }
    };
    document.addEventListener("LUTE:AUTH:LOGIN", this.onLoginHandler);

    // 登录后 redirect 带 hash 回到本模块时，让模块居中显示而非贴在屏幕顶部
    this.scrollToCenterIfNeeded();
  }

  disconnectedCallback() {
    if (this.onIntentCaptureHandler) {
      document.removeEventListener("click", this.onIntentCaptureHandler, true);
    }
    if (this.onLoginHandler) {
      document.removeEventListener("LUTE:AUTH:LOGIN", this.onLoginHandler);
    }
  }

  bindIntentCapture() {
    this.onIntentCaptureHandler = (event) => {
      if (event.target.closest("[data-claim-button]") !== this.button) return;
      // 只有点击当前模块按钮，才写入自动领取意图
      this.markClaimIntent();
    };
    // 使用捕获阶段记录本次点击意图，登录后自动领取
    document.addEventListener("click", this.onIntentCaptureHandler, true);
  }

  buildPageClaimKey() {
    // 用页面路径 + section id 组合成当前模块唯一标识
    const section = this.closest("[data-section-id]");
    const sectionId =
      section && section.dataset.sectionId ? section.dataset.sectionId : "";
    return [
      window.location.pathname,
      sectionId,
      this.dataset.sceneId || "",
    ].join("|");
  }

  markClaimIntent() {
    try {
      // 记录“本模块触发过自动领取登录”标记
      const data = {
        type: "autoClaim",
        pageKey: this.pageClaimKey,
        time: Date.now(),
      };
      sessionStorage.setItem(this.claimIntentStorageKey, JSON.stringify(data));
    } catch (error) {
      console.error("Store claim intent error:", error);
    }
  }

  isCurrentPageIntent() {
    try {
      const raw = sessionStorage.getItem(this.claimIntentStorageKey);
      if (!raw) return false;

      const parsed = JSON.parse(raw);
      // 只有 type 和 pageKey 同时匹配，才算当前模块的自动领取
      return (
        parsed &&
        parsed.type === "autoClaim" &&
        parsed.pageKey === this.pageClaimKey
      );
    } catch (error) {
      console.error("Read claim intent error:", error);
      return false;
    }
  }

  clearClaimIntent() {
    try {
      sessionStorage.removeItem(this.claimIntentStorageKey);
    } catch (error) {
      // ignore
    }
  }

  setLoginRequired() {
    this.currentToken = "";
    // 未登录态：允许点击并打开登录弹框
    this.buttonText.textContent = this.config.loginText;
    this.button.disabled = false;
    this.button.classList.remove("claimed");
    this.button.onclick = () => this.openLoginDialog();
  }

  openLoginDialog() {
    const loginDialog = document.querySelector("login-dialog");
    if (loginDialog && typeof loginDialog.open === "function") {
      const baseUrl = window.location.href.split("#")[0];
      const scrollId = this.rootEl && this.rootEl.id ? this.rootEl.id : "";
      const redirect = scrollId
        ? `${baseUrl}#${scrollId}`
        : window.location.href;
      loginDialog.open(null, {
        activityType: `${this.dataset.activityType || ""}`,
        mustAgreeEmail: true,
        redirect: redirect,
      });
    }
  }

  scrollToCenterIfNeeded() {
    if (!this.rootEl || !this.rootEl.id) return;
    if (window.location.hash !== "#" + this.rootEl.id) return;

    // 等浏览器默认 hash 滚动完成后，再把模块滚到视口中间
    setTimeout(() => {
      if (!this.rootEl) return;
      this.rootEl.scrollIntoView({ block: "center", behavior: "auto" });
    }, 100);
  }

  isResponseOk(data) {
    return data && data.code == 200;
  }

  async checkStatus(token) {
    this.currentToken = token;
    try {
      // 已登录后先查询活动信息及是否已领取
      const res = await fetch(this.checkUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          ...window.__MC__CONFIG__.headers,
        },
      });
      const data = await res.json();

      if (this.isResponseOk(data) && data.result) {
        const result = data.result;

        const giftCardStatus = result.giftCardStatus;
        if (giftCardStatus && giftCardStatus.claimed) {
          // 已领取：直接禁用按钮并展示提示
          this.setClaimed();
        } else {
          // 未领取：根据当前模块标记判断自动领取还是手动领取
          const autoClaim = this.isCurrentPageIntent();
          if (autoClaim) {
            this.clearClaimIntent();
            this.handleClaim(token);
          } else {
            this.setReadyToClaim(token, giftCardStatus);
          }
        }
      } else {
        this.setReadyToClaim(token);
      }
    } catch (error) {
      console.error("Check status error:", error);
      this.setReadyToClaim(token);
    }
  }

  setReadyToClaim(token, giftCardStatus) {
    this.currentToken = token;
    // 可手动领取态：恢复按钮并绑定领取动作
    this.buttonText.textContent = this.config.claimText;
    this.button.disabled = false;
    this.button.classList.remove("claimed");
    this.button.onclick = () => this.handleClaim(token);
  }

  setClaimed() {
    this.buttonText.textContent = this.config.claimedText;
    this.button.disabled = true;
    this.button.classList.add("claimed");
  }

  setStockExhausted() {
    this.buttonText.textContent = this.config.stockExhaustedText;
    this.button.disabled = true;
    this.button.classList.remove("claimed");
  }

  async handleClaim(token) {
    // 发起实际领取请求
    this.buttonText.textContent = this.config.claimingText;
    this.button.disabled = true;

    try {
      const res = await fetch(this.apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          ...window.__MC__CONFIG__.headers,
        },
      });
      const data = await res.json();

      if (this.isResponseOk(data) && data.result) {
        const result = data.result;
        if (result.stockExhausted) {
          this.showToast(this.config.toastStockExhausted);
          this.setStockExhausted();
          return;
        }
        if (result.success || result.alreadyClaimed) {
          this.setClaimed();
        } else {
          throw new Error(data.message || "Claim failed");
        }
      } else {
        throw new Error(data.message || "Claim failed");
      }
    } catch (error) {
      console.error("Claim error:", error);
      this.showToast(this.config.toastError);
      this.setReadyToClaim(token);
    }
  }

  getToken() {
    const cookieName = window.__MC__CONFIG__.cookieName;
    const match = document.cookie.match(new RegExp(`${cookieName}=([^;]+)`));

    return match ? match[1] : null;
  }

  showToast(message) {
    if (typeof T4SThemeSP !== "undefined" && T4SThemeSP.Notices) {
      T4SThemeSP.Notices(message);
      return;
    }
    alert(message);
  }
}

// 注册自定义元素
if (!customElements.get("sep-brand26-claim")) {
  customElements.define("sep-brand26-claim", SepBrand26ClaimComponent);
}
